import Cookies from "js-cookie";

export const setToken = (token: string) => {
  localStorage.setItem("splay:token", token);

  Cookies.set("splay_key", token, {
    domain: import.meta.env.VITE_COOKIE_DOMAIN,
    sameSite: "strict",
    secure: true,
  });
};

export const setProfileInfo = (data: {
  access: string;
  refresh: string;
  profileId: string;
  age?: string;
  age_restrictions?: number;
}) => {
  localStorage.setItem("splay:access", data.access);
  localStorage.setItem("splay:refresh", data.refresh);
  localStorage.setItem("splay:profileId", data.profileId);

  const age = +(data.age_restrictions ?? data.age ?? 18) <= 12 ? data?.age_restrictions : data?.age;
  if (age != undefined) {
    localStorage.setItem("splay:profileAge", age.toString());
  }
};

export const removeProfileInfo = () => {
  localStorage.removeItem("splay:access");
  localStorage.removeItem("splay:refresh");
  localStorage.removeItem("splay:profileId");
  localStorage.removeItem("splay:profileAge");
};

export const removeLoginInfo = () => {
  removeProfileInfo();
  localStorage.removeItem("splay:token");
  Cookies.remove("splay_key", {
    domain: import.meta.env.VITE_COOKIE_DOMAIN,
  });
};
